import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PermissionCheckerService, ServiceRouter } from '@pershing/pershing-core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NXIMISCServiceDefinition } from './nxi-misc-service.definition';
import { PortalComponentServiceDefinition } from './portal-component-service-definition';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    })
};

@Injectable()
export class ModernNavigationService {
    public miscServiceUrl: string;
    serviceUrl: string;
    isCoreStoneCheckRequire: boolean = false;
    fetchBillSUiteUrl = '/billsuite';
    isPayBillValid$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

    constructor(private http: HttpClient,
        private serviceRouter: ServiceRouter,

        private authorizationService: PermissionCheckerService,
        @Optional() @Inject('AppSettings') appSettings: any,) {
        this.miscServiceUrl = this.serviceRouter.getServiceRouteURL(NXIMISCServiceDefinition.getInstance());
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(PortalComponentServiceDefinition.getInstance());
        this.serviceUrl += '/billpay';
        let parsemap = appSettings.ibdConfigMap;
        if (parsemap.isCoreStoneCheckRequire) {
            this.isCoreStoneCheckRequire = parsemap.isCoreStoneCheckRequire;
        }
    }

    getFinancialAdvisorData(reqBody): Observable<any> {
        return this.http.post(this.miscServiceUrl + '/miscservice/advisordetails', reqBody);
    }

    isPayBillEntitled() {
        if (this.authorizationService.isEntitled('BILLSUITE')) {
            if (this.isCoreStoneCheckRequire) {
                this.http.get<Response>(this.serviceUrl + this.fetchBillSUiteUrl, httpOptions).subscribe(
                    (response: any) => {

                        if (JSON.parse(response.accountListJson)?.length > 0) {
                            this.isPayBillValid$.next(true);
                        }
                        else {
                            this.isPayBillValid$.next(false);
                        }
                    },
                    (error: any) => {
                        this.isPayBillValid$.next(false);
                    }
                );
            }
            else {
                this.isPayBillValid$.next(true);
            }
        }

    }

    removeTransactMenu(menuItems: any): any {
        menuItems.filter(e => e.id === "transact").map((x, index) => {
            // check if only paybill menu is available under transact then remove transact menu       
            if (x.id == 'transact') {
                if (x.children.length === 1 && x.children[0].id === "paybills") {
                    menuItems = menuItems.filter(e => e.id != "transact");
                    return;
                }
                // remove only paybills sub menu   
                else {
                    x.children.forEach((y, yIndex) => {
                        if (y.id == 'paybills') {
                            x.children.splice(yIndex, 1);
                            return;
                        }
                    });
                }
            }
        });

        return menuItems
    }
}
